import { distinctUntilChanged, type Observable } from 'rxjs'
import type Member from 'iam/models/Member'
import { filterNonNil } from 'utils/rx-util'
import { createSessionRecordingService } from './SessionRecordingService'
import { take } from 'rxjs/operators'

export * from './SessionRecordingService'
export * from './PostHogSessionRecordingService'
export * from './NoOpSessionRecordingService'

export type SessionRecordingFeature = ReturnType<typeof SessionRecordingFeature>

/**
 * Initializes session recording by wiring up authentication lifecycle events.
 * Identifies the user on login and resets the session on logout.
 */
export function SessionRecordingFeature(
  currentMember$: Observable<Member>,
  logout$: Observable<void>,
) {
  const sessionRecordingService = createSessionRecordingService()

  // Identify user once when they log in
  currentMember$
    .pipe(filterNonNil(), distinctUntilChanged(), take(1))
    .subscribe((member) => {
      sessionRecordingService.identify(member)
    })

  // This is an extra line to reset odee

  // Reset session data when user logs out
  logout$.pipe(take(1)).subscribe(() => {
    sessionRecordingService.reset()
  })

  return {
    sessionRecordingService,
  }
}
